var _rect, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGplText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 54,
    viewBox: "0 0 120 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5997_133463",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 33,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 44.25,
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5997_133463)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.9163 10.6667V6.66667H53.583V4H66.9163V6.66667H61.583V10.6667H58.9163ZM49.583 28V17.3333H52.2497V18.6667H56.2497V14.6667H54.9163V12H65.583V14.6667H64.2497V18.6667H68.2497V17.3333H70.9163V28H68.2497V26.6667H52.2497V28H49.583ZM52.2497 24H68.2497V21.3333H61.583V14.6667H58.9163V21.3333H52.2497V24Z",
    fill: "#D3135A"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.4326 52.112C51.518 52.112 50.6873 51.902 49.9406 51.482C49.194 51.062 48.606 50.474 48.1766 49.718C47.7473 48.9527 47.5326 48.08 47.5326 47.1C47.5326 46.0267 47.7566 45.1167 48.2046 44.37C48.662 43.614 49.264 43.0447 50.0106 42.662C50.7573 42.2793 51.5646 42.088 52.4326 42.088C53.2633 42.088 54.0053 42.2373 54.6586 42.536C55.3213 42.8347 55.844 43.2547 56.2266 43.796C56.6093 44.328 56.8193 44.9393 56.8566 45.63H54.7706C54.696 45.098 54.4486 44.678 54.0286 44.37C53.618 44.0527 53.086 43.894 52.4326 43.894C51.8913 43.894 51.4106 44.0247 50.9906 44.286C50.5706 44.538 50.2393 44.9067 49.9966 45.392C49.7633 45.868 49.6466 46.4373 49.6466 47.1C49.6466 47.7627 49.7633 48.3367 49.9966 48.822C50.2393 49.298 50.5706 49.662 50.9906 49.914C51.4106 50.166 51.8913 50.292 52.4326 50.292C53.0953 50.292 53.632 50.1287 54.0426 49.802C54.4533 49.466 54.6913 49.0133 54.7566 48.444L54.7706 48.318H52.5866V46.638H56.8006C56.8193 46.918 56.8286 47.338 56.8286 47.898C56.8286 48.7753 56.628 49.5313 56.2266 50.166C55.8253 50.8007 55.2886 51.286 54.6166 51.622C53.954 51.9487 53.226 52.112 52.4326 52.112ZM58.2339 52V42.2H62.2659C62.9472 42.2 63.5352 42.3307 64.0299 42.592C64.5339 42.8533 64.9166 43.2173 65.1779 43.684C65.4392 44.1507 65.5699 44.6873 65.5699 45.294C65.5699 45.8913 65.4392 46.4233 65.1779 46.89C64.9166 47.3567 64.5339 47.7253 64.0299 47.996C63.5352 48.2573 62.9472 48.388 62.2659 48.388H60.3479V52H58.2339ZM62.1399 46.638C62.6066 46.638 62.9566 46.512 63.1899 46.26C63.4232 45.9987 63.5399 45.6767 63.5399 45.294C63.5399 44.9113 63.4232 44.594 63.1899 44.342C62.9566 44.0807 62.6066 43.95 62.1399 43.95H60.3479V46.638H62.1399ZM73.2905 52H66.7245V42.2H68.8385V50.18H73.2905V52Z",
    fill: "#D3135A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGplText);
export default __webpack_public_path__ + "static/media/gpl_text.bdea3cb9bd0347288d56bb6d6e3d832c.svg";
export { ForwardRef as ReactComponent };